export default __webpack_public_path__ + "static/media/githubIcon.ec4daa67.svg";